export function toFixed(num: number, fixed = 2) {
  return parseFloat(num.toFixed(fixed));
}
